import { graphql } from 'gatsby'

import { useTranslation } from '@/utils/useTranslation'
import tw from 'twin.macro'
import CopyButton from '@/components/copy-button'

export interface Props {
  contentful_id: string
  type: 'info' | 'warning' | 'success' | 'example'
  theme?: 'light' | 'dark'
  children: JSX.Element
}

export const fragment = graphql`
  fragment Callout on ContentfulComponentCallout {
    __typename
    contentful_id
    type
    body {
      raw
      references {
        ...Asset
        ...Code
        ...ComponentImage
        ...HubSpotForm
        ...Icon
        ...Link
      }
    }
  }
`

export default function Callout({ contentful_id: id, type, children, theme = 'dark' }: Props): JSX.Element {
  const { t } = useTranslation()

  const title = { warning: t('warning'), info: t('note'), success: t('tip'), example: t('example') }
  const icons = { warning: '\ue94b', info: '\ue952', success: '\ue953', example: '\ue953' }
  return (
    <div
      className="group"
      css={[
        tw`px-4 pt-2 mb-4 border border-l-4 border-gray-300 rounded-2xl break-inside-avoid-page`,
        type === 'warning' && tw`border-l-orange-400`,
        type === 'info' && tw`border-l-primaryBlue`,
        type === 'success' && tw`border-l-green-700`,
        type === 'example' && tw`border-l-indigoBlue`,
        theme === 'light' ? tw`bg-white` : tw`bg-gray-200`,
      ]}
    >
      {type === 'example' && (
        <div tw="float-right">
          <CopyButton id={id} theme="light" />
        </div>
      )}

      <h5
        css={[
          tw`flex items-center mb-2 text-2xl font-medium capitalize`,
          type === 'warning' && tw`text-orange-400`,
          type === 'info' && tw`text-primaryBlue`,
          type === 'success' && tw`text-green-700`,
          type === 'example' && tw`text-indigoBlue`,
        ]}
      >
        <span tw="font-bwi mr-1">{icons[type]}</span>
        {title[type]}
      </h5>
      <section id={id}>{children}</section>
    </div>
  )
}
